import {Col, Row} from 'react-bootstrap'
import {GrAttachment} from 'react-icons/gr'
import {Modal} from 'rsuite'
import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import {imageBaseUrl} from 'src/cms/helpers/constants'

type Props = {
  data: {
    id: String
    created_at: string
    grievanceCode: String
    fullName: String
    email: String
    department: {
      id: String
      name: String
      nameNp: String
    } | null
    attachments: String | null
    mobileNumber: String
    message: String
    accountNumber: String
    preferredBranch:
      | [
          {
            id: String
            name: String
          }
        ]
      | null
    serviceCategory: {
      id: String
      name: String
    } | null
    serviceType: {
      id: String
      name: String
    } | null
    serviceSubType: {
      id: String
      name: String
    } | null
    status: {
      id: String
      name: String
      created_at: String
      updated_at: String
      remarks: String
    } | null
  }
  handleClose: () => void
}

const ViewGrievanceDetails = ({data, handleClose}: Props) => {
  const grievanceHandingHideAssignedToFieldInDetailsModal = checkBackendSetting(
    'grievanceHandingHideAssignedToFieldInDetailsModal'
  )
  return (
    <div className='modal-container'>
      <Modal
        open={true}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>Grievance Details </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Row>
              <Col md={3}>Created At : {data?.created_at}</Col>
              <Col md={3}>Full Name : {data?.fullName}</Col>
              <Col md={3}>Email : {data?.email}</Col>
              <Col md={3}>Contact Number: {data?.mobileNumber}</Col>
              <Col md={3}>Account Number: {data?.accountNumber}</Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>Message : {data?.message}</Col>
              {grievanceHandingHideAssignedToFieldInDetailsModal ? null : (
                <Col md={3}>Assigned To: {data?.department?.name || 'N/A'}</Col>
              )}
              <Col md={3}>Status: {data?.status?.name || 'N/A'}</Col>
              <Col md={3}>
                Status Date: {data?.status?.updated_at || data?.status?.created_at || 'N/A'}
              </Col>
              {data?.attachments && (
                <Col>
                  Attachments:
                  <a target='_blank' href={imageBaseUrl + '/' + data?.attachments}>
                    <GrAttachment />
                    View
                  </a>
                </Col>
              )}
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default ViewGrievanceDetails
